import React, { useState, useRef, useEffect } from "react";
/*import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'*/

export const HeadingBlock = ({ as, title, subtitle, description, children }) => {

    const [isExpanded, setIsExpanded] = useState(false);
    const [showButton, setShowButton] = useState(false);
    const textRef = useRef(null);
    const MAX_HEIGHT = 150; // Collapsed height
    const EXPANDED_HEIGHT = 1000; // Large enough value to allow smooth expansion
    const Tag = as || 'h2';
    //const alignClass = props.align == "right" ? "justify-content-end" : "justify-content-start";

    const checkOverflow = () => {
        if (textRef.current) {
            setShowButton(textRef.current.scrollHeight > MAX_HEIGHT);
        }
    };

    useEffect(() => {
        checkOverflow();
        window.addEventListener("resize", checkOverflow);
        return () => window.removeEventListener("resize", checkOverflow);
    }, []);

    return (

        <div className="heading-block">
            <div className="heading-block__title-wrapper">
                <Tag className="heading-block__title heading-block--primary heading-block__title--xl">{title}</Tag>
            </div>

            {subtitle && <p>{subtitle}</p>}

            {(description || children) &&
                <>
                    <div ref={textRef} className={`heading-block__description py-1 py-md-3 expandable-text ${!isExpanded && showButton ? "collapsed" : ""}`}
                        style={{
                            maxHeight: isExpanded ? `${EXPANDED_HEIGHT}px` : `${MAX_HEIGHT}px`,
                            overflow: "hidden",
                            transition: "max-height 0.5s ease-in-out",
                            position: "relative",
                        }}>
                    {description && <p>{description}</p>}
                        {children}
                    </div>
                    {showButton && (
                        <button type="button"
                            className="heading-block__read-more"
                            onClick={() => setIsExpanded(!isExpanded)}
                        >
                            {isExpanded ? "Read Less ▲" : "Read More ▼"}
                        </button>
                    )}
                </>
            }
        </div>


    )
}
